// todo move this logic to payment package
export const ASYNC_OFFER_DIALOG_KEY = 'async_offer_dialog'
